var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.content.Image)?_c('v-img',{staticStyle:{"width":"100%"},attrs:{"src":_vm.content.Image}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }